import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BaseDialog} from "../BaseDialog";
import {IManagableObject} from "../IManagableObject";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'app-group-management-dialog',
    templateUrl: './group-management-dialog.component.html',
    styleUrls: ['./group-management-dialog.component.css'],
    standalone: false
})
export class GroupManagementDialogComponent extends BaseDialog implements OnInit {
  constructor(private translate:TranslateService) {
    super();
    this.dialogId = 'groupMgmtDialog'
  }

  @Output() onAddObjects: EventEmitter<any> = new EventEmitter();

  public object: IManagableObject = new class implements IManagableObject {
    IsChecked: boolean;
    Id: number;
    Name: string;
  };

  public deleteObject(object: IManagableObject) {
    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + object.Name + "?")) return;
    this.doDeleteObject(object);
  }

  private doDeleteObject(object :IManagableObject) {
    let idx = this.objects.indexOf(object);
    if (idx < 0) return;
    this.objects.splice(idx, 1);
    object.IsChecked = false;
    this.selectObjectsCount = this.objects.filter(c => c.IsChecked).length;
  }

  public deleteSelected() {

    let items = this.objects.filter(c => c.IsChecked);
    if (items.length == 0) return;
    let message = this.translate.instant("Delete selected items?");
    if (!confirm(message)) return;
    items.forEach((command) => {
      this.doDeleteObject(command);
    });
  }

  public addObjects() {
    this.onAddObjects.emit();
  }

  public open(model: any) {
    if (model)
      this.object = model;
    super.open(model);
  }

  ngOnInit(): void {
  }
}
